import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StockReplenishmentRunFilterSupplierModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-run-filter-supplier.model";

@Injectable({ providedIn: "root" })
export class StockReplenishmentRunFilterSupplierService extends BaseApiTemplateService<StockReplenishmentRunFilterSupplierModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    "erp/stock-replenishment-run-suppliers/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/stock-replenishment-run-suppliers/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/stock-replenishment-run-suppliers/backoffice-ep";
    this.httpClient = theHttp;
  }
}
